import css from 'styled-jsx/css';

const styles = css.global`.personal {
  margin-top: 40px;
  box-sizing: border-box;
}

.personal.hidden {
  display: none !important;
}

.personal .personal-title {
  font-family: 'SantanderHeadline';
  font-weight: 400;
  font-size: 32px;
  line-height: 42px;
  letter-spacing: 0%;
  color: #222;
  max-width: 288px;
}

.personal .personal-title > img {
  margin-right: 10px;
}

.personal .personal-subtitle {
  font-family: 'SantanderMicroText';
  font-weight: 400;
  font-size: 18px;
  line-height: 28px;
  letter-spacing: 0%;
  color: #222222;
  margin-top: 32px;
}

.personal .button-row {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 40px;
  margin: 40px 0;
}

.personal .text-rooftype {
  font-family: 'SantanderMicroText';
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  letter-spacing: 0%;
  margin-bottom: 16px;
}

.personal .form-render {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  gap: 32px;
  max-width: 520px;
  margin-top: 38px;
}

.personal .button-row-form {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 16px;
  padding-top: 24px;
  margin: 88px 0 0;
  border-top: 1px solid #cccccc;
}

.personal .field-wrapper {
  position: relative;
}

.personal #cta-nao-sei-cep {
  font-family: 'SantanderText';
  font-weight: 400;
  font-style: Regular;
  font-size: 18px;
  line-height: 28px;
  letter-spacing: 0%;
  text-align: right;
  text-decoration: underline;
  text-decoration-style: solid;
  text-decoration-thickness: 0%;

  color: #cc0000;

  cursor: pointer;
  text-align: right;
  margin-left: auto;
  display: block;
  box-sizing: border-box;
  width: fit-content;
}

.personal .form-render .postal-code .text-field__helper.error {
  position: absolute;
  margin: 0;
  bottom: -6px;
  left: 14px;
  transform: translateY(100%);
}

#chk-sem-numero {
  margin-top: 26px;
}

@media (min-width: 992px) {
  .personal .personal-title {
    font-size: 40px;
    line-height: 60px;
    max-width: unset;
  }

  .personal .button-row-form {
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
  }

  .personal .button-row-form button:nth-child(1) {
    max-width: 120px;
  }
  .personal .button-row-form button:nth-child(2) {
    max-width: 228px;
  }
}
`;

export default styles;